import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/Layout.vue";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/authentication/Login.vue"),
  },
  {
    path: "/TwoFactorAuth",
    name: "Two Factor Auth",
    component: () => import("../views/authentication/TwoFactorAuth.vue"),
  },
  {
    path: "/CreatePassword",
    name: "CreatePassword",
    component: () => import("../views/authentication/CreatePassword.vue"),
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () => import("../components/tools/PageNotFound.vue"),
  },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    redirect: "/home",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/compliance/CustomerList",
        name: "List of Customers",
        component: () =>
          import("../components/compliance/users/summary/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/compliance/CustomerKYC",
        name: "Customer KYC",
        component: () =>
          import("../components/compliance/customerKYC/customerKyc.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/compliance/CustomerSearch",
        name: "Customer Search",
        component: () =>
          import("../components/compliance/customerSearch/customerSearch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/compliance/CustomerSummary",
        name: "Manage Customer",
        component: () =>
          import("../components/compliance/ManageCustomer/CustomerSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/addBusCustomer",
        name: "addBusCustomer",
        component: () =>
          import(
            "../components/compliance/ManageCustomer/addCustomer/BusinessUserflow/CreateBusinessuser.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/CustomerFilter",
        name: "Customer Filter",
        component: () =>
          import(
            "../components/compliance/customerSearch/DashboardCustomer.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/list-overview",
        name: "List-Overview",
        component: () =>
          import(
            "../components/compliance/users/summary/Useroverview/list-overview.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      //------------------------Compliance Pages Routes start----------------------//
      {
        path: "/rba-report",
        name: "RBA Report",
        component: () =>
          import("../components/compliance/Reports/compRbareport.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/txn-analysis-report",
        name: "Transaction Analysis Report",
        component: () =>
          import("../components/compliance/Reports/txnAnalysisReport.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      //------------------------Compliance Pages Routes end----------------------//
      //------------------------Customer Pages Routes start----------------------//

      {
        path: "/pushCustomers",
        name: "Push Customer",
        component: () => import("../components/Customer/pushCustomer.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      //------------------------Customer Pages Routes end----------------------//

      {
        path: "/Field-setup",
        name: "Field Setup",
        component: () =>
          import("../components/compliance/Field-setup/Field-setup.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/benfTabs",
        name: "Benficiary Tabs",
        component: () =>
          import("../components/compliance/Beneficiary/benfTabs.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/addCustomer",
        name: "Add Customer",
        component: () =>
          import("../components/compliance/ManageCustomer/CustomerSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/addindCustomer",
        name: "Add Ind Customer",
        component: () =>
          import("../views/Compliance/AddnewCustomer/individual.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: "/compliance/CustomerSummary",
      //   name: "Manage Customer",
      //   component: () =>
      //     import("../components/compliance/ManageCustomer/CustomerSummary.vue"),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      {
        path: "/Transactionpage",
        name: "Transaction Page",
        component: () =>
          import(
            "../components/compliance/Transcationhistory/Transactionpage.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/ManualTransaction",
        name: "Manual Transaction",
        component: () =>
          import(
            "../components/compliance/ManualTransaction/ManualTransactionUpdate.vue"
          ),
      },
      {
        path: "/ForceTransaction",
        name: "Force Transaction",
        component: () =>
          import(
            "../components/compliance/ForceTransaction/ForceTransactionUpdate.vue"
          ),
      },

      {
        path: "/Collectionlimit",
        name: "Collection Limit",
        component: () => import("../views/limits/Collectionlimitcon.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payoutLimit",
        name: "Payout Limit",
        component: () => import("../views/limits/payoutLimit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/complianceLimts",
        name: "Compliance Limit",
        component: () =>
          import("../views/limits/compliancelimts/complianceLimts.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/complianceInd",
        name: "Individual Risk",
        component: () =>
          import(
            "../views/Compliance/compliances/INDcomplinace/complianceInd.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/ComplianceIndValue",
        name: "Compliance IND Value",
        component: () =>
          import(
            "../views/Compliance/compliances/INDcomplinace/ComplianceIndValue.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/CompliancebusValue",
        name: "Compliance BUS Value",
        component: () =>
          import(
            "../views/Compliance/compliances/BUScompliance/CompliancebusValue.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/complianceBus",
        name: "Business Risk",
        component: () =>
          import(
            "../views/Compliance/compliances/BUScompliance/complianceBus.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: "/complianceRules",
      //   name: "Compliance Rules",
      //   component: () =>
      //     import("../components/compliance/Rules/ComplianceRule.vue"),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      {
        path: "/complianceRulesNew",
        name: "Compliance Rules New",
        component: () =>
          import("../components/compliance/Rules/ComplainceRulesNew.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/getCompliancerule",
        name: "Compliance Rules",
        component: () =>
          import("../components/compliance/Rules/getCompliancerule.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/suspiciousList",
        name: "Suspicious Hold List",
        component: () =>
          import(
            "../components/compliance/SuspiciousHoldList/SuspiciousList.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/todaysuspiciousList",
        name: "Suspicious Hold List",
        component: () =>
          import(
            "../components/compliance/SuspiciousHoldList/TodaySusHoldList.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/suspiciousCustomer",
        name: "Suspicious Customer",
        component: () =>
          import(
            "../components/compliance/SuspiciousHoldList/suspiciousCustomer.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/suspiciousHoldDetails",
        name: "Suspicious Details",
        component: () =>
          import(
            "../components/compliance/SuspiciousHoldList/SuspiciousTxnhold/HoldTxnDetails.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Listofuser",
        name: "List Of Users",
        component: () => import("../components/Users/adminUser/Listofuser.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Adduser",
        name: "Add User",
        component: () => import("../components/Users/adminUser/Adduser.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/addPartener",
        name: "Add Partner",
        component: () =>
          import("../components/Users/partnerUser/addPartener.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/listOfPartners",
        name: "List Of Partners",
        component: () =>
          import("../components/Users/partnerUser/listOfPartners.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/security",
        name: "Security",
        component: () => import("../components/Users/2FA/TwoFactAuth.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/NewRole",
        name: "New Role",
        component: () => import("../views/Roles/CreateNewRole.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/RolesSummary",
        name: "Roles Summary",
        component: () => import("../views/Roles/RoleSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Previlege",
        name: "Previlege",
        component: () => import("../views/Roles/PrevilegeList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/RolesList",
        name: "Roles List",
        component: () => import("../views/Roles/RolesList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/EditRole/:roleid/:rolename",
        name: "EditRole",
        component: () => import("../views/Roles/EditRole.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/modules-for-roles",
        name: "modules-for-roles",
        component: () => import("../views/DeveloperMode/ModulesForRoles.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/sub-modules",
        name: "sub-modules",
        component: () =>
          import("../views/DeveloperMode/SubModulesForRoles.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // Setting pages routes start here//
      {
        path: "/settings/cronejobs",
        name: "Jobs",
        component: () => import("../views/Settings/cronejobs/Cronejobs.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/settings/sanctions-bulk-upload",
        name: "Sanctions Bulk Upload",
        component: () =>
          import("../views/Settings/SanctionsBulkUpload.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/MasterData",
        name: "Master Data",
        component: () => import("../views/Settings/masterData/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Masterdatavalue",
        name: "Master Data Value",
        component: () =>
          import("../views/Settings/masterData/Masterdatavalue.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/SubCategoryValue",
        name: "Sub CategoryValue",
        component: () =>
          import("../views/Settings/masterData/SubCategoryValue.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/MasterPartnerdatavalue",
        name: "Master Partner Value",
        component: () =>
          import("../views/Settings/masterDataMap/masterPartnerDataValue.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/MasterDataMap",
        name: "Master Data Mapping",
        component: () =>
          import("../views/Settings/masterDataMap/MasterDataMapping.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/MasterDataMapValue",
        name: "Master Data Map Value",
        component: () =>
          import("../views/Settings/masterDataMap/masterDataValue.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/settings/PasswordFormat",
        name: "Password Format",
        component: () => import("../views/Settings/passwordFormat.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/settings/TaxConfiguratoion",
        name: "Tax Configuration",
        component: () => import("../views/Settings/TaxConfiguration.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/settings/masterBank",
        name: "Master Bank",
        component: () => import("../views/Settings/masterBank/masterBank.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/settings/masterBankvalue",
        name: "Master Bank Value",
        component: () =>
          import("../views/Settings/masterBank/masterBankvalue.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Country",
        name: "Country Setup",
        component: () => import("../views/Country/Countrysetup.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/CountryAdditional",
        name: "Country Additional",
        component: () => import("../views/Country/CountryDetails.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Transactionlog",
        name: "Transaction Log",
        component: () =>
          import("../views/Compliance/logs/TransctionLogs/Transactionlog.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/TransactionReport",
        name: "Transaction Reports data",
        component: () => import("../views/transaction/TransactionReport.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/errorLogs",
        name: "Error",
        component: () =>
          import("../views/Compliance/logs/errorLog/errorLogs.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/apiLog",
        name: "Api",
        component: () => import("../views/Compliance/logs/Apilog/apiLog.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/customerAduit",
        name: "Customer Audit",
        component: () =>
          import("../views/Compliance/logs/Aduitlogs/customerAduit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/adminuserAduit",
        name: "Admin Audit",
        component: () =>
          import("../views/Compliance/logs/Aduitlogs/adminuserAduit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/loginUser",
        name: "Login User",
        component: () =>
          import("../views/Compliance/logs/userLoginlog/loginUser.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/locekdcustomers",
        name: "Locked Customers",
        component: () =>
          import("../views/Compliance/logs/Lockedlogs/LockedCustomers.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/locekdusers",
        name: "Locked Users",
        component: () =>
          import("../views/Compliance/logs/Lockedlogs/LockedUsers.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Transactionlocked",
        name: "Transaction Locked",
        component: () =>
          import("../views/Compliance/logs/Lockedlogs/Transactionlocked.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Transactionmodified",
        name: "Transaction Modified",
        component: () =>
          import(
            "../views/Compliance/logs/TransctionLogs/Transactionmodifeid.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Transactionaudit",
        name: "Transaction Audit",
        component: () =>
          import("../views/Compliance/logs/Aduitlogs/Transactionaduit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/integrationLog",
        name: "Integration",
        component: () =>
          import("../views/Compliance/logs/IntegrationLog/integrationLog.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/createPartner",
        name: "Create Partner",
        component: () =>
          import("../views/partner/partnerCreation/Createpartner.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/summary",
        name: "Partner Summary",
        component: () => import("../views/partner/partnerSummary/Summary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Todaysummary",
        name: "Partner Summary",
        component: () =>
          import("../views/partner/partnerSummary/TodayRegPartners.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/userSearch",
        name: "User Search",
        component: () => import("../views/partner/userSearch/userSearch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/masterBankSummary",
        name: "Master Bank Summary",
        component: () => import("../views/partner/MasterBank/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/masterBranchSummary",
        name: "MasterBranch Summary",
        component: () =>
          import("../views/partner/MasterBank/MasterBranchSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/partnerBankSummary",
        name: "partnerBank Summary",
        component: () =>
          import("../views/partner/partnerBank/partnerBankSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/partnerBranchSummary",
        name: "partnerBranch Summary",
        component: () =>
          import("../views/partner/partnerBank/partnerBranchSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/supportiveBank",
        name: "Supportive Bank",
        component: () => import("../views/partner/supportiveBank.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/usersetup",
        name: "User Setup",
        component: () => import("../views/partner/partnerUser/userSetup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/userlist",
        name: "User Summary",
        component: () =>
          import("../views/partner/partnerUser/userBranchSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/createAgent",
        name: "Create Agent",
        component: () =>
          import("../views/partner/partnerAgent/CreateAgent.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/agentlist",
        name: "Agent Summary",
        component: () =>
          import("../views/partner/partnerAgent/AgentSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/partnerMasterdata",
        name: "Partner MaterData",
        component: () =>
          import(
            "../views/Settings/masterData/customMasterData/PartnerMaterData.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/branchlist",
        name: "Branch Summary",
        component: () =>
          import("../views/partner/partnerBranch/BranchSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/branchsetup",
        name: "Branch Setup",
        component: () =>
          import("../views/partner/partnerBranch/BranchSetup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/bankList",
        name: "Bank List",
        component: () =>
          import("../views/partner/partnerSummary/Bank/bankList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/editBank",
        name: "Edit Bank",
        component: () =>
          import("../views/partner/partnerSummary/Bank/editBank.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Branchname",
        name: "Bank Branch",
        component: () =>
          import("../views/partner/partnerSummary/Branch/Branchname.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/partnerBranch",
        name: "Partner Branch",
        component: () =>
          import("../views/partner/partnerSummary/Branch/partnerBranch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/editBranch",
        name: "Edit Branch",
        component: () =>
          import("../views/partner/partnerSummary/Branch/editBranch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/userDetails",
        name: "User Detail",
        component: () =>
          import("../views/partner/partnerSummary/user/userDetails.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/mainBranch",
        name: "Main Branch",
        component: () =>
          import("../views/partner/partnerSummary/Branch/mainBranch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/newBranch",
        name: "New Branch",
        component: () =>
          import("../views/partner/partnerSummary/Branch/newBranch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/newUser",
        name: "New User",
        component: () =>
          import("../views/partner/partnerSummary/user/newUser.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payoutCommission",
        name: "Payout Commission",
        component: () =>
          import(
            "../views/partner/partnerSummary/Commission/payoutCommission.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //     path: "/partner-setup/Deposit/PayeeRoute",
      //     name: "PayeeRoute",
      //     component: () =>
      //         import("../views/Compliance/partner/PayeeRoute.vue"),
      //     meta: {
      //         requiresAuth: true
      //     }
      // },
      {
        path: "/manageCollectionpoint",
        name: "Manage Collection Point",
        component: () => import("../views/partner/manageCollectionpoint.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/PayRoutestep",
        name: "Payee Route",
        component: () => import("../views/partner/payRoutee/payRoutestep.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/partnerRoutestep",
        name: "Partner Route",
        component: () => import("../views/partner/partnerRoutee.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/payoutPartner",
        name: "Payout Partner Bank Summary",
        component: () => import("../views/partner/payoutPartner.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/Addpayroute",
        name: "Add Payee Route",
        component: () =>
          import("../views/partner/payRoutee/payrouteetabs/Addpayroute.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/depositChannel",
        name: "Deposit Channel",
        component: () =>
          import("../views/partner/depositChannel/depositChannel.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/createDepositchannel",
        name: "Create Deposit Channel",
        component: () =>
          import("../views/partner/depositChannel/createDepositchannel.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/partnerUtilities",
        name: "Partner Utilities",
        component: () => import("../views/partner/partnerUtilities/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // -----------------------------------Exchange Rates pages -----------------------------------
      {
        path: "/fxCostRate",
        name: "FX Rate Cost",
        component: () => import("../views/RatesExchange/RatesSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/fxCostRatebiz",
        name: "FX Rate Cost Biz",
        component: () => import("../views/RatesExchange/RateSummaryBiz.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/fxRateSetup",
        name: "FX Rate Setup",
        component: () => import("../views/RatesExchange/fxRatesSetup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/fxExchangeRateSetup",
        name: "FX Exchange Rate Setup",
        component: () =>
          import("../views/FxExchangeRate/FxExchangeRateSetup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/FXRateUpdateBiz",
        name: "FX Rate Update-Biz",
        component: () =>
          import("../views/FxExchangeRate/FxExchangeRatesBiz.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/FXRateHistory",
        name: "FX Rate History",
        component: () =>
          import("../views/FxExchangeRate/FxEXchangeRateHistory.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/fxrateSchedule",
        name: "FX Cost Schedule",
        component: () =>
          import("../views/FxExchangeRate/FxRateSchedule/fxrateSchedule.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // -------------------Treasury Views Routes --------------------------------------//
      {
        path: "/Treasury/deals",
        name: "Deals",
        component: () => import("../views/treasury/Deals/Deals.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/newDeal",
        name: "New Deal",
        component: () => import("../views/treasury/Deals/NewDeal.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/dealsBu",
        name: "Business Deals",
        component: () => import("../views/treasury/Deals/BUSDeals/DealsBu.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/newdealsBu",
        name: "New Business Deals",
        component: () =>
          import("../views/treasury/Deals/BUSDeals/NewDealBu.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/newSettlement",
        name: "NewSettlement",
        component: () =>
          import("../views/treasury/Settlement/NewSettlement.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/LedgerAccount",
        name: "Account Details",
        component: () =>
          import("../views/treasury/LedgerAccounts/LedgerAccountSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/sampleLedger",
        name: "Sample Ledger",
        component: () =>
          import("../views/treasury/LedgerAccounts/SampleLedger.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/funding",
        name: "Funding",
        component: () => import("../views/treasury/Funding/Funding.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/Rates",
        name: "Rates",
        component: () => import("../views/treasury/Rates/ratesSetup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/NewFunding",
        name: "New Funding",
        component: () => import("../views/treasury/Funding/NewFunding.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/settlements",
        name: "Settlements",
        component: () => import("../views/treasury/Settlement/Settlements.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/voucherEntry",
        name: "Voucher Entry",
        component: () => import("../views/treasury/Voucher/voucherEntry.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/voucherApproval",
        name: "Voucher Not Approved",
        component: () =>
          import("../views/treasury/Voucher/voucherApproval.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Treasury/voucherReport",
        name: "Voucher Report",
        component: () => import("../views/treasury/Voucher/voucherReport.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/Blacklist/sanctionListupload",
        name: "Sanction List Upload",
        component: () => import("../views/BlackList/sanctionListupload.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Blacklist/sanctionList",
        name: "Sanction List",
        component: () => import("../views/BlackList/sanctionList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Blacklist/sanctionListhistory",
        name: "Sanction List History",
        component: () => import("../views/BlackList/sanctionListhistory.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Blacklist/sanctionSearch",
        name: "Sanction Search",
        component: () => import("../views/BlackList/sanctionSearch.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Blacklist/sanctionSearchresult",
        name: "Sanction Search Result",
        component: () => import("../views/BlackList/sanctionSearchresult.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/Blacklist/Manualcompliance",
        name: "Manual Sanction Entry",
        component: () => import("../views/BlackList/Manualcompliance.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/TransHoldpage",
        name: "Hold Transactions",
        component: () =>
          import("../components/compliance/Transactionhold/TransHoldpage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/serviceCharge",
        name: "Service Charge Setup",
        component: () =>
          import("../components/ServiceCharge/serviceChargeMain.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/ServiceChargeSetupBiz",
        name: "Service Charge Setup Biz",
        component: () =>
          import(
            "../components/ServiceCharge/ServiceChargeSetup-Biz/ServiceChargeSetup-Biz.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/TransHoldDetails",
        name: "Hold Details",
        component: () =>
          import("../components/compliance/Transactionhold/HoldTxnDetails.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/TransPush",
        name: "Push Transactions",
        component: () =>
          import("../components/Transactions/PushTxns/PushTxnList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: "/transaction/:stepCount?",
      //   name: "Transactions",
      //   component: () => import("../views/transaction/Transaction.vue"),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      {
        path: "/CustomerList",
        name: "Transactions",
        component: () => import("../views/transaction/CustomerList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/cancelTransaction",
        name: "Cancel Transaction",
        component: () => import("../views/transaction/CancelTransaction.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/transactionDetails",
        name: "Transaction Details",
        component: () => import("../views/transaction/TransactionDetails.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/riskProfiling",
        name: "Risk Profiling",
        component: () => import("../views/riskProfiling/RiskProfiling.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/riskProfiling",
        name: "Risk Profiling",
        component: () => import("../views/riskProfiling/RiskProfiling.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/statementReport",
        name: "Statement Report",
        component: () =>
          import("../views/treasury/AccountStatements/StatementReport.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/stateOfAccount",
        name: "Statement Of Account",
        component: () =>
          import("../views/treasury/AccountStatements/StatementOfAccount.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/v2transactionreport",
        name: "Transaction Report",
        component: () => import("../views/Report/ReportData.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/rspreport",
        name: "RSP Report",
        component: () => import("../views/Report/RspReport.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      //--------------------- Domestic Payments-----------------------------//
      {
        path: "/customerUpdate",
        name: "Customer Update",
        component: () =>
          import("../components/DomesticPayments/CustomerList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/domestic-customer",
        name: "Domestic-Customer",
        component: () =>
          import(
            "../components/DomesticPayments/users/summary/Useroverview/list-overview.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payin",
        name: "Pay-In",
        component: () => import("../components/DomesticPayments/PayIn.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payout",
        name: "Pay-Out",
        component: () => import("../components/DomesticPayments/PayOut.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payin-Transaction-Info",
        name: "Pay-In-Transaction-Info",
        component: () =>
          import(
            "../components/DomesticPayments/PayInAndPayOutTransaction/payInTransactionInfo.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payout-Transaction-Info",
        name: "Pay-Out-Transaction-Info",
        component: () =>
          import(
            "../components/DomesticPayments/PayInAndPayOutTransaction/payOutTransactionInfo.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/rspreport",
        name: "RSP Report",
        component: () => import("../views/Report/RspReport.vue"),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "/complianceSetup",
        name: "Compilance Setup",
        component: () =>
          import(
            "../components/compliance/compliance setup/complianceSetup.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("fullpath", from.fullPath);
  const authenticatedUser = sessionStorage.getItem("__ac_mn_tk");
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  sessionStorage.setItem("prevPath", from.fullPath);
  // Check for protected route
  if (requiresAuth && !authenticatedUser) {
    next("/login");
  } else if (!requiresAuth && authenticatedUser) {
    next("/home");
  } else {
    next();
    console.log("route", to);
  }
});

export default router;
